import { Component, Host, Prop, h, Watch, Element } from '@stencil/core';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

@Component({
  tag: 'video-block',
  styleUrl: 'video-block.css',
  shadow: false,
})
export class VideoBlock {
  @Prop() videoUrl: string;
  @Prop() videoLoop: string;
  @Prop() videoClass: string;
  player: any;

  @Element() el: HTMLElement;

  @Watch('videoUrl')
  videoUrlChanged(newValue: string, oldValue: string) {
    if (newValue !== oldValue) {
      this.setupPlayer();
    }
  }

  componentDidLoad() {
    this.setupPlayer();
  }

  setupPlayer() {
    // Destroy existing player instance if it exists
    if (this.player) {
      this.player.dispose(); // Use dispose() for Video.js
      this.player = null;
    }
    // Early return if there's no videoUrl
    if (!this.videoUrl || this.videoUrl === '' || this.videoUrl === null || this.videoUrl === undefined) {
      return;
    }

    // Setup player again with the new videoUrl
    const videoElement = this.el.querySelector('#player');
    if (this.videoUrl.startsWith('https://www.youtube.com/watch?v=')) {
      const videoId = this.videoUrl.split('v=')[1];
      const embedUrl = `https://www.youtube.com/embed/${videoId}?origin=https://plyr.io&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1`;
      videoElement.innerHTML = `<iframe src="${embedUrl}" allow="autoplay" allowfullscreen></iframe>`;
    } else {
      if (this.videoLoop == 'true') {
        videoElement.innerHTML = `<video id="video-js" class="video-js ${this.videoClass}" autoplay loop muted playsinline>
        <source src="${this.videoUrl}" type="video/mp4" />
        </video>`;
      } else {
        videoElement.innerHTML = `<video id="video-js" class="video-js ${this.videoClass}" controls autoplay muted>
        <source src="${this.videoUrl}" type="video/mp4" />
        </video>`;
      }
    }

    // Initialize Video.js player
    const videoTag = videoElement.querySelector('video');
    if (videoTag) {
      this.player = videojs(videoTag, {}, function onPlayerReady() {
        console.log('Player is ready!');
      });
    }
  }

  render() {
    return (
      <Host>
        <div id="player" class={`video-embed ${this.videoClass}`}></div>
      </Host>
    );
  }
}
